import { Download } from 'lucide-react'
import { QRCodeCanvas, QRCodeSVG } from 'qrcode.react'
import { useRef } from 'react'
import { Button } from './button'

const PNG_SIZE = 1600
const QUIET_ZONE_MODULES = 4

/** A button that saves a QR code as a large PNG with a quiet zone, ready for print. */
export function QrPngButton({
  value,
  fileName,
  label,
  className,
}: {
  value: string
  fileName: string
  label: string
  className?: string
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  const download = () => {
    canvasRef.current?.toBlob((blob) => {
      if (!blob) return
      const href = URL.createObjectURL(blob)
      const anchor = document.createElement('a')
      anchor.href = href
      anchor.download = `${fileName}.png`
      anchor.click()
      setTimeout(() => URL.revokeObjectURL(href))
    }, 'image/png')
  }

  return (
    <>
      <QRCodeCanvas
        ref={canvasRef}
        value={value}
        size={PNG_SIZE}
        marginSize={QUIET_ZONE_MODULES}
        className="hidden"
        aria-hidden
      />
      <Button variant="outline" className={className} onClick={download}>
        <Download className="mr-2 h-4 w-4" />
        {label}
      </Button>
    </>
  )
}

/** A QR code on print paper with a button that saves it as a large PNG. */
export function QrDownload({
  value,
  title,
  fileName,
  downloadLabel,
}: {
  value: string
  title: string
  fileName: string
  downloadLabel: string
}) {
  return (
    <>
      <div className="rounded-lg bg-print-paper p-2">
        <QRCodeSVG
          value={value}
          marginSize={QUIET_ZONE_MODULES}
          className="h-auto w-full"
          title={title}
        />
      </div>
      <QrPngButton value={value} fileName={fileName} label={downloadLabel} className="w-full" />
    </>
  )
}
